import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const CallToAction: React.FC = () => {
  return (
    <section className="py-20 px-6 relative overflow-hidden">
      <div className="absolute inset-0 z-0">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-yellow-500/10 to-purple-500/10 opacity-50"></div>
        {/* Musical Staff Lines */}
        {[...Array(5)].map((_, i) => (
          <div 
            key={i} 
            className="absolute h-px bg-gray-700/30 w-full" 
            style={{ top: `${20 + i * 10}%` }}
          ></div>
        ))}
        
        {/* Animated Notes */}
        {[...Array(10)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute text-gray-700/20"
            initial={{ 
              x: '-10%', 
              y: 20 + (i * 10) + '%',
              rotate: Math.random() * 20 - 10,
              scale: Math.random() * 0.5 + 0.5
            }}
            animate={{ 
              x: '110%',
            }}
            transition={{ 
              duration: Math.random() * 20 + 30, 
              repeat: Infinity,
              ease: "linear"
            }}
            style={{ fontSize: `${Math.random() * 2 + 1}rem` }}
          >
            {['♪', '♫', '♬', '♩', '♭', '♮', '♯'][Math.floor(Math.random() * 7)]}
          </motion.div>
        ))}
      </div>
      
      <div className="max-w-4xl mx-auto text-center relative z-10">
        <motion.h2 
          className="text-3xl md:text-5xl font-bold mb-6"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          Ready to Learn Spanish Through Music?
        </motion.h2>
        
        <motion.p 
          className="text-xl text-gray-300 mb-8"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          Join thousands of students who are mastering Spanish while enjoying their favorite songs.
        </motion.p>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <Link 
            to="/register" 
            className="inline-block bg-gradient-to-r from-yellow-400 to-yellow-500 text-black px-8 py-4 rounded-full font-bold text-lg hover:from-yellow-300 hover:to-yellow-400 transform hover:scale-105 transition-all duration-200 shadow-lg"
          >
            Start Your Free Trial
          </Link>
          <p className="mt-4 text-sm text-gray-400">No credit card required. 7-day free trial.</p>
        </motion.div>
      </div>
    </section>
  );
};

export default CallToAction;